import { render, staticRenderFns } from "./select-group.vue?vue&type=template&id=48e52e48&scoped=true"
import script from "./select-group.vue?vue&type=script&lang=js"
export * from "./select-group.vue?vue&type=script&lang=js"
import style0 from "./select-group.vue?vue&type=style&index=0&id=48e52e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e52e48",
  null
  
)

export default component.exports